//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'login',
    data() {
        return {
            formData: {
                userid: '',
                auth: ''
            }
        };
    },
    methods: {
        async login() {
            await this.$x.post('login/login', this.formData)
            this.$router.replace('/');
        }
    },
    components: {}
}
